import type { ReactNode } from "react";
import type { FeatureKey, PublicAppConfig } from "@plataforma/shared";
import { AgendaPage } from "../features/agenda/AgendaPage";
import { ClientProfilePage } from "../features/clients/ClientProfilePage";
import { ClientsPage } from "../features/clients/ClientsPage";
import { FinancePage } from "../features/finance/FinancePage";
import { InvoicesPage } from "../features/invoices/InvoicesPage";
import { ReportsPage } from "../features/reports/ReportsPage";
import { SettingsPage } from "../features/settings/SettingsPage";

export interface FeatureModule {
  key: FeatureKey;
  path: string;
  icon: string;
  label: (config: PublicAppConfig) => string;
  routes: { path: string; element: ReactNode }[];
}

/**
 * Catálogo de funcionalidades do frontend. Menu e rotas saem daqui, filtrados pela configuração
 * da aplicação; acrescentar uma tela é acrescentar uma entrada, sem tocar na casca.
 */
export const featureModules: FeatureModule[] = [
  { key: "agenda", path: "/agenda", icon: "▦", label: () => "Agenda", routes: [{ path: "/agenda", element: <AgendaPage /> }] },
  { key: "clients", path: "/clientes", icon: "◉", label: (config) => config.settings.terms.client.plural, routes: [{ path: "/clientes", element: <ClientsPage /> }, { path: "/clientes/:id", element: <ClientProfilePage /> }] },
  { key: "invoices", path: "/notas-fiscais", icon: "▤", label: () => "Notas fiscais", routes: [{ path: "/notas-fiscais", element: <InvoicesPage /> }] },
  { key: "finance", path: "/financeiro", icon: "▥", label: () => "Financeiro", routes: [{ path: "/financeiro", element: <FinancePage /> }] },
  { key: "reports", path: "/relatorios", icon: "▧", label: () => "Relatórios", routes: [{ path: "/relatorios", element: <ReportsPage /> }] },
  { key: "settings", path: "/configuracoes", icon: "⚙", label: () => "Configurações", routes: [{ path: "/configuracoes", element: <SettingsPage /> }] },
];

export const enabledFeatures = (config: PublicAppConfig, modules: FeatureModule[] = featureModules): FeatureModule[] => modules.filter((module) => config.features.includes(module.key));
